import { useEffect, useState } from 'react'
import { CIMSBasicFieldProps } from '../../../CIMSBasicFields/types'
import { useFoundCallback } from './useFoundCallback'
import { EntityValue } from '../../types'
import EntityCustomFields from '../../components/EntityCustomFields'
import { useProjectContext } from 'context/ProjectContext'

export function useEntityCustomFields(
  entityValues?: EntityValue[]
): CIMSBasicFieldProps[] {
  const [fields, setFields] = useState<CIMSBasicFieldProps[]>([])
  const found = useFoundCallback()
  const { projectId } = useProjectContext()
  useEffect(() => {
    if (!entityValues) return
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    setFields(
      entityValues.map(({ customFieldId, entities, customField }) =>
        found({
          hidden: !entities.length,
          customField,
          customFieldId,
          children: (
            <EntityCustomFields
              entities={entities}
              customFieldId={customFieldId}
            />
          ),
        })
      )
    )
  }, [found, entityValues, projectId])
  return fields
}
